/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ActorTypes {
  None = 0,
  Sender = 1,
  Receiver = 2,
  Invoice = 4,
  Declarant = 8,
  Delegate = 16,
  Exporter = 32,
  Importer = 64,
  Consolidator = 128,
  Shipper = 256,
  Manufacturer = 512,
  WarehouseOwner = 1024,
  Guarantee = 2048,
  CustomsPayer = 4096,
  Seller = 8192,
  Buyer = 16384,
}
